var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"placeholder"},[_c('div',{ref:"container",class:("" + (_vm.$style.container))},[_c('div',{ref:"sticky",class:("overflow-visible " + (_vm.$style.sticky)),style:(("top:" + _vm.offset))},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }